import React from "react";
import "../my-calender.scss";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import PropTypes from "prop-types";
import ReactCountryFlag from "react-country-flag";
import { format } from "date-fns";

const EventList = ({
  events,
  handleSelectEvent,
  handleCloseEventDetailCalander,
}) => {
  const formatMilestoneDate = (dateString) => {
    if (dateString) {
      return format(dateString, "MMMM do, yyyy");
    } else {
      ("-");
    }
  };
  return (
    <div className="event-list-container">
      <div className="header-container">
        <h2 className="header-title"> Upcoming Events</h2>
        <span className="close-sidebar">
          <i
            className="pi pi-times"
            onClick={handleCloseEventDetailCalander}
          ></i>
        </span>
      </div>

      <div className="content-container">
        <p className="date">Date: {formatMilestoneDate(events[0]["start"])}</p>
        {events?.map(
          ({
            title,
            subTitle,
            label,
            type,
            country,
            start,
            oneliner,
            id,
            status,
            end,
            color,
            backgroundColor,
            process,
            entityData,
            due_date_utc,
            processData,
          }) => (
            <Card
              key={id}
              style={{
                borderInlineStartColor: color,
                backgroundColor: backgroundColor,
              }}
              onClick={() => {
                handleSelectEvent(
                  {
                    title,
                    subTitle,
                    label,
                    type,
                    country,
                    start,
                    oneliner,
                    id,
                    status,
                    end,
                    color,
                    backgroundColor,
                    process,
                    entityData,
                    due_date_utc,
                    processData,
                  },
                  true,
                );
              }}
            >
              <p className="event-service-name">{label}</p>
              <p className="event-name-status">
                {`${title} (${status?.name})`}
              </p>
              <p className="event-process-name">{processData?.name}</p>
              <p className="event-entity-name">
                <ReactCountryFlag
                  countryCode={entityData.country || ""}
                  svg
                  className=""
                />
                {" " + entityData.name}
              </p>
              <p className="event-due-date">
                Deadline: {formatMilestoneDate(start)}
              </p>
            </Card>
          ),
        )}
      </div>
    </div>
  );
};

EventList.propTypes = {
  events: PropTypes.array,
  handleCloseEventDetailCalander: PropTypes.func,
  handleSelectEvent: PropTypes.func,
};

export default EventList;
